import type { FC } from "react";
import HomePageDonkeycomm from "../components/homepage/donkeycomm";
import HomePageNipau from "../components/homepage/nipau";
import HomePageSempre from "../components/homepage/sempre";
import HomePageGommaire from "../components/homepage/gommaire";
import HomePageMelmath from "../components/homepage/mapmath";

const Home: FC = () => {
  if (process.env.REACT_APP_THEME === "nipau") {
    return <HomePageNipau />;
  } else if (process.env.REACT_APP_THEME === "nipau") {
    return <HomePageNipau />;
  }

  switch (process.env.REACT_APP_COMPANY_NAME) {
    case "Donkeycomm":
      return <HomePageDonkeycomm />;
    case "Gommaire":
      return <HomePageGommaire />;
    case "Melmath":
      return <HomePageMelmath />;
    case "Nipau":
      return <HomePageNipau />;
    case "Sempre":
      return <HomePageSempre />;
    default:
      return <HomePageDonkeycomm />;
  }
};

export default Home;
